export default __webpack_public_path__ + "static/media/fechar.8416659a.svg";